import React, { useCallback } from 'react';
import Title from '../../atoms/title/title.js';

const DurationItem = ({ duration, durationText, durationSubText, mostPopular, selected = false, onDurationSelected, isNewUser = false, topLabel, useYourBalanceText, secondsText, bottomContainer, priceContainer }) => {
    const selectedClassName = (className) => selected ? `${className}-selected` : className;
    const newUserClassName = (className) => isNewUser ? selectedClassName(className) : "";
    const renderDurationText = () => (React.createElement("div", { "data-testid": "mbw-duration-item-duration-text", className: "mbw-duration-item-duration-text" },
        React.createElement(Title, { fontStyle: "heading-h5", bold: true }, durationText)));
    const renderDurationSecondsText = () => secondsText ? (React.createElement("div", { "data-testid": "mbw-duration-item-duration-seconds-text", className: "mbw-duration-item-duration-seconds-text" }, React.createElement(Title, { fontStyle: "caption-1", bold: true }, secondsText))) : null;
    const renderDurationTextMobile = () => (React.createElement("div", { "data-testid": "mbw-duration-item-duration-text", className: "mbw-duration-item-duration-text-mobile" }, isNewUser ? React.createElement(Title, { fontStyle: "heading-h5", bold: true }, durationText)
        : React.createElement(Title, { fontStyle: "heading-h4", bold: true }, durationText)));
    const renderDuration = () => (React.createElement("div", { className: "mbw-duration-item-duration-container" },
        React.createElement("div", { "data-testid": "mbw-duration-item-duration", className: selectedClassName("mbw-duration-item-duration") }, duration),
        renderDurationText(),
        renderDurationTextMobile(),
        renderDurationSecondsText(),
        durationSubText));
    const renderMostPopular = () => (React.createElement("div", { "data-testid": "mbw-duration-item-most-popular" }, mostPopular));
    const renderTopLabel = () => (React.createElement("div", { "data-testid": "mbw-duration-item-top-label" }, topLabel));
    const renderUseYourBalanceText = () => (React.createElement("div", { "data-testid": "mbw-duration-item-current-balance", className: "mbw-duration-item-current-balance" },
        React.createElement(Title, { fontStyle: "content-small", bold: true }, useYourBalanceText)));
    const renderAdditionalText = useCallback(() => {
        if (useYourBalanceText)
            return renderUseYourBalanceText();
        return priceContainer;
    }, [useYourBalanceText]);
    return (React.createElement("div", { "data-testid": "mbw-duration-item", className: selectedClassName("mbw-duration-item") + newUserClassName(" mbw-duration-item-new-user"), onClick: onDurationSelected, onKeyDown: onDurationSelected },
        renderMostPopular(),
        renderTopLabel(),
        renderDuration(),
        renderAdditionalText(),
        bottomContainer));
};

export { DurationItem as default };
//# sourceMappingURL=duration_item.js.map
